import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-content-section'
})
export default class EdContentSection extends Vue {

  /* Properties */
  @Prop() readonly type: string;
  @Prop() readonly hasCreateOption: boolean;
  @Prop() readonly hasSeeAll: boolean;
  @Prop() readonly seeAllAction: Function;
  @Prop() readonly createItemAction: Function;

  /* Methods */
  createItem() {
    this.$emit('createItemAction');
  }

  seeAll() {
    this.$emit('seeAllAction', this.type);
  }

}